import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCut } from "react-icons/fa";
import Navbar from "../../components/Navbar/Navbar";
import Ticket from "../../components/Ticket/Ticket";
import { useAuth } from "../../hooks/useAuth";
import "./BarberHome.css";
import { FiLogOut } from "react-icons/fi";

export default function BarberHome() {
  const { userSession } = useAuth();
  const barberId = userSession?.id;

  const [appointments, setAppointments] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    // Postavljanje intervala za refresh svakih 10 minuta (600000 milisekundi)
    const intervalId = setInterval(() => {
      window.location.reload();
    }, 600000); // 600000 ms = 10 minuta

    // Čišćenje intervala kad se komponenta unmounta
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!barberId) return;

    axios
      .get(`/api/appointments-by-barber/${barberId}`)
      .then((res) => setAppointments(res.data))
      .catch((err) => console.error("Error fetching appointments:", err));

    axios
      .get(`/api/service-by-barber/${barberId}`)
      .then((res) => setServices(res.data))
      .catch((err) => console.error("Error fetching services:", err));
  }, [barberId]);

  const getServiceName = (service_id) => {
    const service = services.find((s) => s.id === service_id);

    return service ? service.name : "Nepoznata usluga";
  };

  return (
    <div className="barber-home">
      <Navbar
        className="navbar"
        leftIcon={FaCut}
        leftLink="/barber-settings"
        rightIcon={FiLogOut}
        isLogout
      />
      <h2 className="barber-title">Moji termini</h2>
      <div className="ticket-container">
        {appointments.length > 0 ? (
          appointments
            .slice() // kopira array da ne mijenja original
            .sort((a, b) => a.time_slot.localeCompare(b.time_slot)) // sortira po vremenu
            .map((appointment) => (
              <Ticket
                key={appointment.id}
                time={appointment.time_slot.slice(0, 5)} // skrati "12:00:00" u "12:00"
                name={`${appointment.name} ${appointment.last_name}`}
                service={getServiceName(appointment.service_id)}
              />
            ))
        ) : (
          <p className="no-appointments">Nema zakazanih termina.</p>
        )}
      </div>
    </div>
  );
}
